import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_input = _resolveComponent("el-input");
    const _component_Dialog = _resolveComponent("Dialog");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_el_input, {
            size: $props.size,
            placeholder: $props.placeholder,
            value: $props.modelValue,
            readonly: "",
            onClick: $options.openSelect
        }, null, 8, [
            "size",
            "placeholder",
            "value",
            "onClick"
        ]),
        $data.visible ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            ref: "Dialog",
            modelValue: $data.url,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.url = $event),
            "show-external": $props.showExternal,
            onSubmit: $options.submit,
            onClear: $options.clear,
            onClosed: _cache[1] || (_cache[1] = ($event)=>$data.visible = false)
        }, null, 8, [
            "modelValue",
            "show-external",
            "onSubmit",
            "onClear"
        ])) : _createCommentVNode("", true)
    ], 64);
}
